module.exports = __webpack_public_path__ + "img/badge-success-task.7ec4cbc4.svg";